import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getUserById } from '../../utils/API/getUserDetails'
import SellerProjectCard from '../../components/atoms/SellerProjectCard'
import Button from '../../components/atoms/Button'
import useScrollToTop from '../../hooks/useScrollToTop'
import FilterDialogBox from '../molecules/FilterDialogBox'
import { ReactComponent as Filter } from '../../components/svgs/Filterrblack.svg'
import { getUsersList } from '../../utils/API/getUsersList'
import { useNavigate } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import SearchBar from '../atoms/SearchButton'
import { Skeleton } from 'antd'
import ProjectListLoader from '../atoms/ProjectListLoader'
import { useSelector } from 'react-redux'

const ProfileDescription = () => {
  const { _id } = useParams()
  const [userData, setUserData] = useState(null)
  const [isFilterDialogOpen, setFilterDialogOpen] = useState(false)
  const [showProject, setShowProject] = useState(true)
  const [loading, setLoading] = useState(true)
  const [searchItem, setSearchItem] = useState('')
  const [selectedType, setSelectedType] = useState(null)
  const [selectedUserType, setSelectedUserType] = useState(null)
  const [filterData, setFilterData] = useState(null)

  useScrollToTop()
  const [usersData, setUsersData] = useState([])
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const currentPage = Number(searchParams.get('page')) || 1
  const { userType, kycVerified } = useSelector(state => state.authReducer)

  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0
  })

  const pageSize = 8

  const fetchUsers = async () => {
    try {
      setLoading(true)
      const response = await getUsersList(
        {
          searchQuery: searchItem,
          user_type: filterData?.user_type,
          status: filterData?.type,
          currentPage: currentPage,
          pagelimit: pageSize
        },

        dispatch
      )
      const data = response.data
      if (data) {
        setUsersData(data) // Corrected this line
        setPagination({
          totalItems: data.totalDocs,
          totalPages: data.totalPages,
          pageSize: data.pageSize
        })

        if (currentPage > data.totalPages) {
          setSearchParams({ page: data.totalPages })
        }
      }
    } catch (error) {
      console.error('Error fetching user data:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleFilterDialogClose = () => {
    setSelectedType(null)
    setSelectedUserType(null)
    setFilterData(null)
    setFilterDialogOpen(false)
  }

  const handleSearch = () => {
    // console.log(searchItem)
  }

  const handleTypeCheck = e => {
    const selectedValue = e.target.value
    setSelectedType(selectedValue)
  }

  const handleUserTypeCheck = e => {
    const selectedValue = e.target.value
    setSelectedUserType(selectedValue)
  }

  const handleFilterDialogSubmit = () => {
    setFilterDialogOpen(false)
    setFilterData({
      type: selectedType ? selectedType : null,
      user_type: selectedUserType ? selectedUserType : null
    })
  }

  useEffect(() => {
    fetchUsers()
  }, [currentPage, pagination.pageSize, searchItem, filterData])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getUserById(_id)
        if (response) {
          setUserData(response)
          setLoading(false)
        } else {
          console.error('Error fetching user data')
          setLoading(false)
        }
      } catch (error) {
        console.error('Error fetching user data:', error)
        setLoading(false)
      }
    }
    fetchData()
  }, [_id])

  return (
    <div className='flex w-full capitalize'>
      <div className='w-2/3 2xl:w-2/3 md:w-3/5 h-[50rem] bg-[#F4F6FA] '>
        <div className='flex'>
          <div className='w-4/5 h-[40px] flex p-1 ml-[1rem]  mt-4 rounded-lg'>
            <SearchBar
              onSearch={handleSearch}
              searchItem={searchItem}
              setSearchItem={setSearchItem}
              variant='secondaryxl'
              className='text-black w-full h-full'
              borderColor='border-none'
              placeholderColor='blue-800'
              inputBackground='blue'
              svgStrokeColor='blue'
              inputWidth='full'
              inputHeight='9'
            />
          </div>
          <div className='ml-[1rem] mt-5 whitespace-nowrap'>
            <Button
              onClick={() => {
                navigate('/all-users')
              }}
              variant='primary'
              borderColor='blue'
              className='px-10 w-30 font-bold py-[6px] text-sm rounded-md text-white bg-blue-800'
            >
              See All
            </Button>
          </div>
        </div>
        <div>
          {!userData ? (
            <div className='flex flex-col gap-y-4 p-4'>
              <Skeleton.Button block={true} active={true} />
              <Skeleton.Button block={true} active={true} />
              <Skeleton.Button block={true} active={true} />
              <Skeleton.Button block={true} active={true} />
            </div>
          ) : (
            <div>
              <div className='relative'>
                {userData.cover_image ? (
                  <img
                    className='ml-4 mt-4 w-[840px] 2xl:w-[51rem] md:w-[700px] h-[120px]'
                    src={userData.cover_image}
                    alt='Cover Image'
                  />
                ) : (
                  <div className='ml-4 mt-4 w-[840px] 2xl:w-[51rem] md:w-[700px] h-[120px] flex items-center justify-center bg-gray-200'>
                    No cover image
                  </div>
                )}
                {userData.profile_image ? (
                  <img
                    className='absolute rounded-full top-[80%] left-[4%] w-[90px] h-[90px]'
                    src={userData.profile_image}
                    alt='Profile Image'
                  />
                ) : (
                  <div className='absolute rounded-full top-[80%] left-[4%] w-[90px] h-[90px] flex items-center justify-center bg-gray-200'>
                    <p className='pl-5 text-xs'> No profile image</p>
                  </div>
                )}
              </div>
              <div className='ml-[18%] mt-2'>
                <h1 className='leading-9 text-black text-[20px] font-normal'>
                  {userData.name}
                </h1>
                <h1 className='font-bold text-[15px] text-[#878787]'>
                  {userData.user_type}
                </h1>
              </div>
              <div className='flex w-full relative'>
                <div className='ml-10 mt-16'>
                  <h1 className='text-[20px] text-[#4361EE] font-bold'>
                    {userData.kycType}
                  </h1>
                  <h3 className='text-[15px] font-normal text-black mt-2'>
                    {userData.location}
                  </h3>
                </div>
                <div className=' absolute right-[5%]'>
                  <h1 className='text-[15px] font-bold text-[#878787]'>
                    Transaction Done
                  </h1>
                  <h1 className='text-[#4361EE] font-bold text-[50px] text-right'>
                    {userData.transactions}
                  </h1>
                </div>
              </div>
              <div className='ml-10 mt-10 w-[90%] flex flex-col'>
                <div className='flex justify-between'>
                  <div className='flex'>
                    {' '}
                    <h1 className='text-[#4361EE] text-[24px] font-bold leading-5'>
                      Authenticity
                    </h1>
                    <img
                      className='w-[15px] h-[15px] mt-[3px] ml-[2%]'
                      src='/images/info.svg'
                      alt='/'
                    />
                  </div>

                  <div className='text-blue-800 text-[24px] font-bold '>
                    {userData.authenticity}%
                  </div>
                </div>

                <div className='w-full h-2 bg-grey-300 mt-2 rounded-full'>
                  <div
                    className='h-1 rounded-full bg-blue-800'
                    style={{
                      height: `${100}%`,
                      width: `${userData.authenticity}%`
                    }}
                  ></div>
                </div>
              </div>
              <div className='ml-10 mr-10 mt-10 w-fit'>
                <h1 className='text-black text-[25px] font-bold leading-5'>
                  About
                </h1>
                <p className='text-[#465257] text-[12px] font-normal mt-4 mb-4'>
                  {}
                </p>
                {userData.about}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='pl-0'>
        <>
          <div className=' flex justify-between pt-8 pl-8 pb-4'>
            <div className='flex justify-between text-lg font-medium'>
              Explore More
            </div>
            <div className=''>
              <Button
                varient='rounded'
                borderColor='black'
                onClick={() => setFilterDialogOpen(true)}
                className='w-40 focus-visible:outline-0 text-xl font-normal justify-center pl-1 py-1  bg-blue-200  flex items-center'
              >
                Filter{' '}
                <span className='pl-12'>
                  <Filter />
                </span>
              </Button>
            </div>
          </div>
          <div>
            {loading ? (
              <ProjectListLoader />
            ) : (
              usersData.map((user, index) => (
                <SellerProjectCard
                  key={index}
                  userId={user['_id']}
                  userTitle={user['name']}
                  userType={user['user_type']}
                  userLocation={user['location']}
                  isProfileDescription={true}
                />
              ))
            )}
            <div className=' flex ml-3 my-5 justify-center '>
              <Button
                onClick={() => {
                  navigate('/all-users')
                }}
                variant='primary'
                borderColor='blue'
                className='px-10 w-full font-bold py-[6px] text-sm rounded-md text-white bg-blue-800'
              >
                See More
              </Button>
            </div>
          </div>
        </>
      </div>
      {isFilterDialogOpen && (
        <FilterDialogBox
          open={isFilterDialogOpen}
          onCancel={handleFilterDialogClose}
          onOk={handleFilterDialogSubmit}
          onCheckType={handleTypeCheck}
          selectedType={selectedType}
          setSelectedType={setSelectedType}
          selectedUserType={selectedUserType}
          onCheckUserType={handleUserTypeCheck}
          showProject={false}
        />
      )}
    </div>
  )
}

export default ProfileDescription
